import styled, { css } from 'styled-components';

const columnSizeToBreakpoint = {
    c4: null,
    c8: 'tabletPortraitUp',
    c12: 'tabletLandscapeUp',
};
function generateColumnStyle(sizeOrRange, breakpoint, theme) {
    const mediaQuery = columnSizeToBreakpoint[breakpoint];
    let columnStyle = null;
    if (!Array.isArray(sizeOrRange)) {
        columnStyle = css `
      grid-column: ${sizeOrRange} span;
    `;
    }
    else {
        columnStyle = css `
      grid-column: ${sizeOrRange[0]} / ${sizeOrRange[1]} span;
    `;
    }
    if (!mediaQuery) {
        return columnStyle;
    }
    return css `
    ${theme.media[mediaQuery]} {
      ${columnStyle}
    }
  `;
}
const StyledGridColumn = styled.div `
  box-sizing: border-box;

  ${({ breakpoints = {}, theme }) => Object.keys(breakpoints).reduce((acc, breakpoint) => {
    const sizeOrRange = breakpoints[breakpoint];
    if (typeof sizeOrRange !== 'number' && !Array.isArray(sizeOrRange))
        return acc;
    return css `
        ${acc}${generateColumnStyle(sizeOrRange, breakpoint, theme)}
      `;
}, '')};
`;

export { StyledGridColumn };
